import { LIGHT_GENE_BG } from './styles';


export class MutationBlockRadial {
//

  constructor(mutation, pct, count, isWildType) {
    this.mutation = mutation;
    this.pct = pct;
    this.count = count;
    this.angle = 0;
    this.cosA = 0;
    this.sinA = 0;
    this.r1 = 0;
    this.r2 = 0;
    this.atarget = 0;
    this.color = LIGHT_GENE_BG;
    this.label = isWildType ? (mutation.refAA === 'DEL' ? '' : mutation.refAA)
      : mutation.isDeletion ? '∆' : mutation.altAA || mutation.refAA;
  }


  draw(ctx) {
    /* set by the mutation block for now */
    // if (this.border) {
    //   ctx.lineWidth = this.border;
    //   ctx.strokeStyle = 'white';
    //   ctx.beginPath();
    //   ctx.moveTo(this.x - this.border * 0.5, this.y);
    //   ctx.lineTo(this.x - this.border * 0.5, this.y + this.h);
    //   ctx.moveTo(this.x + this.w + this.border * 0.5, this.y);
    //   ctx.lineTo(this.x + this.w + this.border * 0.5, this.y + this.h);
    //   ctx.stroke();
    // }
    if (ctx.strokeStyle !== this.color) {
      ctx.stroke();
      ctx.strokeStyle = this.color;
      ctx.beginPath();
    }
    ctx.moveTo(this.cosA * this.r1, this.sinA * this.r1);
    ctx.lineTo(this.cosA * this.r2, this.sinA * this.r2);
  }


  drawLetter(ctx) {
    let {label, cosA, sinA, r1, r2} = this,
      r = (r1 + r2) * 0.5;
    ctx.fillText(label, cosA * r, sinA * r);
  }


}
